import {Card, Col, List, Radio, Row, DatePicker} from 'antd';
import moment from 'moment';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import followUpsIcon from '../../assets/icons/registration/followUpsIcon.png';
import CallLogListDrawer from '../../containers/dashboard/callLoglist';
import ListDrawer from '../../containers/dashboard/list';
import Request from '../../request';
import styles from './styles.less';
import ActiveIcon from '../../assets/icons/ActiveIcon.png';
import {getUrlPushWrapper} from "../../routes";
import DidntPickCallIcon from '../../assets/icons/DidntPickCallIcon.png';
import BusyIcon from '../../assets/icons/BusyIcon.png';
import coldIcon from '../../assets/icons/coldIcon.png';
import NotInterestedIcon from '../../assets/icons/NotInterestedIcon.png';
import OutOfTownIcon from '../../assets/icons/OutOfTownIcon.png';
import LeadsIcon from '../../assets/icons/LeadsIcon.png';

import {
    FaBlenderPhone,
    FaHeadphones,
    FaRunning,
    FaHeadset
} from "react-icons/fa";
import { RightsWrapper } from '../_utils/utils';

const data = [
    {name: 'Group A', value: 525},
    {name: 'Group B', value: 175}
];

const {RangePicker} = DatePicker

const COLORS = ['#56BFEE', '#69ccf9'];

class TelecallerCounts extends Component {

    constructor(props) {
        super(props)
        this.state = {
            value: 'lastMonth',
            newCounselling: [],
            drawer: false,
            callDrawer: false,
            drawerParam: {},
            drawerCallParam: {},
            followupDataCount: {},
            todayFollowupDataCount: {},
            overdueFollowupDataCount: {},
            totalConverted: {
                total: 0
            },
            callAttempts: {
                total: 0
            },
            callMisseds: {
                total: 0
            },
            callConnecteds: {
                total: 0
            },            
            dateRangeFilter: {
                startDate: moment().startOf('day').toDate(),
                endDate: moment().endOf('day').toDate(),
            },
            todayDoneFollowUps: {},
            todayFollowCounsellorWise: [],
            todayFollowRatingWise: [],
            totalRatingCount: 0,
            totalCounsellingWiseCount: 0
        }
    }


    async componentDidMount() {    
        let {dateRangeFilter} = this.props 
        this.setState({dateRangeFilter})
        this.loadAllApis();
    }

    loadTelecallerGraph = async(telecallerId) => {
        let dateRangeFilter = this.state.dateRangeFilter;
        let response = await Request.getTelecallerGraphData({telecallerId, dateRangeFilter});
        this.setState({            
            todayDoneFollowUps: response.data,
            todayFollowCounsellorWise: response.counsellorWiseCount && response.counsellorWiseCount.data ? response.counsellorWiseCount.data : [],
            todayFollowRatingWise: response.ratingWiseCount && response.ratingWiseCount.data ? response.ratingWiseCount.data : [],
            totalCounsellingWiseCount: response.counsellorWiseCount && response.counsellorWiseCount.totalCounsellingWiseCount ? response.counsellorWiseCount.totalCounsellingWiseCount : 0,
            totalRatingCount: response.ratingWiseCount && response.ratingWiseCount.totalRatingCount ? response.ratingWiseCount.totalRatingCount : 0,
        })
    }

    loadAllApis = () => {
        let localUser = JSON.parse(localStorage.getItem('user'));
        this.loadTelecallerGraph(localUser._id);
        let params = {userId: localUser._id}
        Request.getFollowupsData(params).then(({data: followupDataCount}) => {
            this.setState({followupDataCount})
        });
        Request.getTodayFollowupsData(params).then(({data: todayFollowupDataCount}) => {
            this.setState({todayFollowupDataCount})
        });
        Request.getOverdueFollowupsData(params).then(({data: overdueFollowupDataCount}) => {
            this.setState({overdueFollowupDataCount})
        });
    }
    chooseRangerPicker = (date, dateString) => {
    
        this.setState(
          {
            dateRangeFilter: {
              startDate: date[0],
              endDate: date[1],
            },
          },
          () => {
          }
        );
        setTimeout(() => {
            let localUser = JSON.parse(localStorage.getItem('user'));
            this.loadTelecallerGraph(localUser._id);
        }, 500);
    };

    componentWillReceiveProps(props) {
        const {timer} = this.props;
        if (props.timer !== timer) {
            this.loadAllApis();
        }
    }

    render() {
        const {dispatch} = this.props;
        const {
            todayFollowCounsellorWise,
            todayFollowRatingWise,
            totalRatingCount,
            totalCounsellingWiseCount,
            todayDoneFollowUps
        } = this.state

        return (
            <div>
                <RightsWrapper myRight={"TelecallerCounts.view"}>
                <Row>
                        <Col span={8} >
                            <h4>FILTER BY CREATED DATE</h4>
                            <RangePicker
                                key={"326"}
                                showTime={{ format: "HH:mm" }}
                                format="YYYY-MM-DD HH:mm"
                                placeholder={["Start Time", "End Time"]}
                                onChange={this.chooseRangerPicker}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Card 
                            title={
                                <span>
                                    <img src={LeadsIcon} alt="card" height={22} width={22}/>  
                                    <span style={{paddingLeft: '10px'}}>Counsellor Wise Count ({totalCounsellingWiseCount})</span>
                                </span>
                            }
                            headStyle={{
                                backgroundColor: '#6d6d6d',
                                color: 'white',
                                minHeight: '11px',
                                fontSize: '15px'
                            }}
                            bodyStyle={{padding: '12px'}} bordered={false}
                            style={{marginTop: '15px'}}>
                            <Row> 
                                {
                                    todayFollowCounsellorWise.map((counsellorWise, index) => {
                                        return(
                                            <Col span={8} style={{marginBottom: '10px'}} key={index}> 
                                                <Row>
                                                    <Col span={3}>
                                                        <img src={ActiveIcon} alt="card"/>
                                                    </Col>
                                                    <Col>
                                                        <div className={styles.followups}>{counsellorWise.counsellor}</div>
                                                        <div className={styles.followupsNumber} style={{color: '#8ac545', marginLeft: '40px'}}> 
                                                            {
                                                                counsellorWise.count                                                            
                                                            }
                                                        </div>
                                                    </Col>
                                                </Row> 
                                            </Col>
                                        )
                                    })
                                }
                            </Row>
                        </Card>        
                    </Row>
                    <Row>
                        <Card 
                            title={
                                <span>
                                    <img src={LeadsIcon} alt="card" height={22} width={22}/>  
                                    <span style={{paddingLeft: '10px'}}>Rating Wise Count ({totalRatingCount})</span>
                                </span>
                            }
                            headStyle={{
                                backgroundColor: '#6d6d6d',
                                color: 'white',
                                minHeight: '11px',
                                fontSize: '15px'
                            }}
                            bodyStyle={{padding: '12px'}} bordered={false}
                            style={{marginTop: '15px'}}>
                            <Row> 
                                {
                                    todayFollowRatingWise.map((ratingWise, index) => {
                                        return(
                                            <Col span={8} style={{marginBottom: '10px'}} key={index}> 
                                                <Row>
                                                    <Col span={3}>
                                                        <img src={ActiveIcon} alt="card"/>
                                                    </Col>
                                                    <Col>
                                                        <div className={styles.followups}>{ratingWise.rating}</div>
                                                        <div className={styles.followupsNumber} style={{color: '#8ac545', marginLeft: '40px'}}> 
                                                            {
                                                                ratingWise.count                                                            
                                                            }
                                                        </div>
                                                    </Col>
                                                </Row> 
                                            </Col>
                                        )
                                    })
                                }
                            </Row>
                        </Card>        
                    </Row>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Card title={
                                <span>
                                    <img src={followUpsIcon} alt="Smiley face" height="22" width="22"/>
                                    <span style={{paddingLeft: '10px'}}>Today's Completed Followups ({todayDoneFollowUps && todayDoneFollowUps.totalFollowupCount ? todayDoneFollowUps.totalFollowupCount : 0})</span>
                                </span>
                            }
                            headStyle={{
                                backgroundColor: '#6d6d6d',
                                color: 'white',
                                minHeight: '11px',
                                fontSize: '17px'
                            }}
                            bodyStyle={{padding: '34px'}} bordered={false}
                            style={{height: '145px', marginTop: '15px'}}>
                                <Row> 
                                    <Col span={3}> 
                                        <Row>
                                            <Col span={3}>
                                                <img src={ActiveIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Active</div>
                                                {
                                                    todayDoneFollowUps && todayDoneFollowUps.activeCount != 0 ? 
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Active'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#8ac545'}}>
                                                                {todayDoneFollowUps && todayDoneFollowUps.activeCount}
                                                            </div>
                                                        </a> 
                                                    : <div className={styles.followupsNumber} style={{color: '#8ac545'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                    <Col span={5}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={DidntPickCallIcon} alt="Smiley face"height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Didn't Pick Call</div>
                                                {
                                                    todayDoneFollowUps && todayDoneFollowUps.pickCallCount != 0 ? 
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Didn\'t Pick up Call'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: 'orange'}}>
                                                                {todayDoneFollowUps && todayDoneFollowUps.pickCallCount}
                                                            </div>
                                                        </a> 
                                                    :
                                                        <div className={styles.followupsNumber}style={{color: 'orange'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                    <Col span={5}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={BusyIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Busy(Call Later)</div>
                                                {
                                                    todayDoneFollowUps && todayDoneFollowUps.busyCallCount != 0 ? 
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Busy, Call Later'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#5dc294'}}>
                                                                {todayDoneFollowUps && todayDoneFollowUps.busyCallCount}
                                                            </div>
                                                        </a> 
                                                    :
                                                        <div className={styles.followupsNumber} style={{color: '#5dc294'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                    <Col span={5}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={NotInterestedIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Not Intrested</div>
                                                {
                                                    todayDoneFollowUps && todayDoneFollowUps.notInterestedCount != 0 ?
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Not Interested'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#8e8e8e'}}>
                                                                {todayDoneFollowUps && todayDoneFollowUps.notInterestedCount}
                                                            </div>
                                                        </a> 
                                                    : 
                                                        <div className={styles.followupsNumber} style={{color: '#8e8e8e'}}> 0</div>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={4}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={OutOfTownIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Out of Town</div>
                                                {
                                                    todayDoneFollowUps && todayDoneFollowUps.outOfTownCount != 0 ?
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Out Of town'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#607d8b'}}>
                                                                {todayDoneFollowUps && todayDoneFollowUps.outOfTownCount}
                                                            </div>
                                                        </a> 
                                                    : <div className={styles.followupsNumber} style={{color: '#607d8b'}}> 0</div>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={2}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={coldIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Cold</div>
                                                {
                                                    todayDoneFollowUps && todayDoneFollowUps.coldCount != 0 ? 
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Cold'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#0b91d3'}}>
                                                                {todayDoneFollowUps && todayDoneFollowUps.coldCount}
                                                            </div>
                                                        </a> 
                                                    : <div className={styles.followupsNumber} style={{color: '#0b91d3'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                    </RightsWrapper>
                </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapDispatchToProps)
(TelecallerCounts)
